export interface IconSetConfig {
    icons: NodeListOf<HTMLElement>,
    thumbnails: NodeListOf<HTMLElement>
}

export class IconSet {
    private readonly elemenst: {
        icons: NodeListOf<HTMLElement>,
        thumbnails: NodeListOf<HTMLElement>
    };

    constructor({icons, thumbnails}: IconSetConfig) {
        this.elemenst = {icons, thumbnails};
        this.bind();
    }

    protected onThumbnailClick(button: Element): void {
        const name = button.getAttribute(`data-name`);
        const icon = [...this.elemenst.icons].find(icon => {
            return icon.matches(`[data-name="${name}"]`)
        });
        if (icon) this.highlightIcon(icon);
    }

    protected onIconClick(trigger: HTMLElement): void {
        this.highlightIcon(trigger);
        const thumbnail = this.findThumbnail();
        this.renderIcon(trigger, thumbnail);
    }

    public highlightIcon(icon: HTMLElement): void {
        this.elemenst.icons.forEach(icon => icon.classList.remove(`is-active`));
        icon.classList.add(`is-active`);
    }

    public findThumbnail(): Element {
        return Array.from(this.elemenst.thumbnails).find(thumbnail => {
            const button = thumbnail.querySelector(`[role=button]`);
            return button.classList.contains(`is-triggered`);
        });
    }

    public renderIcon(trigger: HTMLElement, target: Element): void {
        const storage = target.querySelector(`[type=hidden]`) as HTMLInputElement;
        const button = target.querySelector(`[role=button]`);
        const svg = trigger.querySelector(`svg`);
        const name = trigger.getAttribute(`data-name`);

        storage.value = name;
        storage.setAttribute(`data-storage`, name);
        button.setAttribute(`data-name`, name);
        button.replaceChild(svg.cloneNode(true), button.firstChild);
    }

    protected bind(): void {
        const {icons, thumbnails} = this.elemenst;
        if (!icons || !thumbnails) return;

        icons.forEach( icon => {
            icon.addEventListener('click', () => this.onIconClick(icon));
        });
        thumbnails.forEach(thumbnail => {
            const button = thumbnail.querySelector(`[role=button]`);
            button.addEventListener('click', () => this.onThumbnailClick(button));
        })
    }
}